/**
 * Feature flag keys used throughout the application
 * These correspond to PostHog feature flag names
 *
 * Keep this in sync with:
 * - PostHog dashboard feature flag configuration
 * - Feature flag hooks in src/hooks/useHas*.ts
 * - MenuItem type in src/components/global/Sidebar/components/MenuListItem/types.ts
 */
export const FEATURE_FLAGS = {
  PROJECT_PORTFOLIO: 'has_project_portfolio',
  EMPLOYEE_PORTFOLIO: 'has_employee_portfolio',
  EMBEDDABLE_POC: 'has_embeddable_poc',
  NEW_EXPENSE_UI: 'has_new_expense_ui',
  NEW_PROJECT_MANAGEMENT: 'has_new_project_management',
  DASHBOARDS_REPORTING: 'has_dashboards_reporting',
} as const;

/**
 * Type representing all valid feature flag keys
 * Automatically derived from FEATURE_FLAGS constant
 */
export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
